import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { map } from 'rxjs/operators';

import Table from '../../../../../components/common/table/table';
import { ButtonComponent } from '../../../../../components/form/elements/button';
import { FieldHistoryDataAnalysesTable } from '../../../../../interfaces/field-history';
import { useService } from '../../../../../services/services';
import css from './analyses.module.css';

export default function FieldHistoryDataAnalysisIndex() {
  const { t } = useTranslation();
  const tp = useCallback(
    (key: string) =>
      t(
        'pages.crop.field-history.history.section.data.analysis.fields.'.concat(
          key
        )
      ),
    [t]
  );
  const { fieldService } = useService();
  const { farmId, season, id } = useParams<{
    farmId: string;
    season: string;
    id: string;
  }>();
  const [isExpanded, setExpanded] = useState(false);

  const request = useCallback(
    (page: number, sort: string, desc: boolean, filter: any) =>
      fieldService.fieldHistorySectionDataAnalysis(farmId, season, id).pipe(
        map((response) => ({
          ...response,
          data:
            isExpanded || !response.data.length
              ? response.data
              : [response.data[0]],
        }))
      ),
    [fieldService, farmId, season, id, isExpanded]
  );

  return (
    <>
      <Table<FieldHistoryDataAnalysesTable>
        request={request}
        keyAccessor="id"
        paginate={false}
        columns={[
          {
            accessor: 'date',
            header: tp('date'),
          },
          {
            accessor: 'soil_granulometric_composition',
            header: tp('soil_granulometric_composition'),
          },
          {
            accessor: 'organic_substances',
            header: tp('organic_substances'),
          },
          {
            accessor: 'pH',
            header: tp('pH'),
          },
          {
            accessor: 'P2O5',
            header: tp('P2O5'),
          },
          {
            accessor: 'K2O',
            header: tp('K2O'),
          },
          {
            accessor: 'other_value',
            header: tp('other_value'),
          },
        ]}
      />
      <div className={css['expand']}>
        <ButtonComponent
          name="expand"
          label={t(
            'pages.crop.field-history.history.section.data.analysis.expand'
          )}
          click={() => setExpanded(true)}
        />
      </div>
    </>
  );
}
